<script>
import { CellGroup, Cell } from 'vant'
import ImageViewer from '@/components/org/ImageViewer'
import BottomToolbar from '@/components/org/BottomToolbar'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-brand-detail',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell-group': CellGroup,
        'van-cell': Cell,
        'image-viewer': ImageViewer,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            matchBrand: {
                id: null,
                name: null,
                logoUrl: null,
                area: null,
                crowdLabel: null,
            },
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onEditBtnClick() {
            console.log('onEditBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditMatchBrand',
                    params: { id: this.matchBrand.id }
                }
            })
        },
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
    },
}
</script>

<template>
    <div class="match-brand-detail">
        <van-cell-group>
            <van-cell :title="locale['match-brand-name-label']" :value="matchBrand.name"/>
            <image-viewer
                :label="locale['match-brand-logo-label']"
                :imageUrl="adjustImageSize(matchBrand.logoUrl, 160, 160)"
                :previewImageUrl="adjustImageSize(matchBrand.logoUrl, 750, 750)"
            />
            <van-cell :title="locale['city-region']" :value="matchBrand.area"/>
            <van-cell :title="locale['sport-type']" :value="locale['sport-type-1']"/>
            <van-cell :title="locale['match-brand-crowd-label']" :value="matchBrand.crowdLabel"/>
        </van-cell-group>
        <bottom-toolbar 
            type="button" 
            :mainButtonLabel="locale['edit']"
            @click-main-button="onEditBtnClick"
        />
    </div>
</template>